var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFittingGlasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#EBFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.9043C16.9191 18.9043 20.0957 22.0809 20.0957 26C20.0957 29.9191 16.9191 33.0957 13 33.0957C9.0809 33.0957 5.9043 29.9191 5.9043 26C5.9043 22.0809 9.0809 18.9043 13 18.9043Z",
    fill: "url(#paint0_linear_7401_27217)",
    stroke: "url(#paint1_linear_7401_27217)",
    strokeWidth: 1.80769
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 18.9043C31.0809 18.9043 27.9043 22.0809 27.9043 26C27.9043 29.9191 31.0809 33.0957 35 33.0957C38.9191 33.0957 42.0957 29.9191 42.0957 26C42.0957 22.0809 38.9191 18.9043 35 18.9043Z",
    fill: "url(#paint2_linear_7401_27217)",
    stroke: "url(#paint3_linear_7401_27217)",
    strokeWidth: 1.80769
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24.625C13.7594 24.625 14.375 25.2406 14.375 26C14.375 26.7594 13.7594 27.375 13 27.375C12.2406 27.375 11.625 26.7594 11.625 26C11.625 25.2406 12.2406 24.625 13 24.625Z",
    fill: "#00A3E0",
    stroke: "#00A3E0",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24.625C34.2406 24.625 33.625 25.2406 33.625 26C33.625 26.7594 34.2406 27.375 35 27.375C35.7594 27.375 36.375 26.7594 36.375 26C36.375 25.2406 35.7594 24.625 35 24.625Z",
    fill: "#00A3E0",
    stroke: "#00A3E0",
    strokeWidth: 1.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26L27 26",
    stroke: "url(#paint4_linear_7401_27217)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14H42",
    stroke: "url(#paint5_linear_7401_27217)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7401_27217",
    x1: 8.36,
    y1: 18,
    x2: 6.78469,
    y2: 33.2766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7401_27217",
    x1: 21,
    y1: 26,
    x2: 5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7401_27217",
    x1: 39.64,
    y1: 18,
    x2: 41.2153,
    y2: 33.2766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7401_27217",
    x1: 34.9787,
    y1: 18,
    x2: 34.9787,
    y2: 32.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7401_27217",
    x1: 21,
    y1: 26.5,
    x2: 27,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039CDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0591D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7401_27217",
    x1: 42,
    y1: 14.5,
    x2: 6,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0A7CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFittingGlasses);
export default __webpack_public_path__ + "static/media/no-fitting-glasses.fd20b3f62bb2c96ce76fb56d37ec4376.svg";
export { ForwardRef as ReactComponent };